
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { SharedService } from 'src/app/shared/services/shared.service';

@Component({
    selector: 'app-select-btn',
    templateUrl: './select-btn.component.html',
    styleUrl: './select-btn.component.scss',
    standalone: true,
    imports: []
})
export class SelectBtnComponent implements ICellRendererAngularComp {
  params: any;

  constructor(public sharedService: SharedService) {

  }

  agInit(params: any): void {
    this.params = params;
  }
  refresh(params?: any): boolean {
    // needed for the ICellRendererAngularComp
    return true;
  }

  // Button functions
  selectClick() {
    const rowData = {
      colValues: this.params.node.data,
      rowIndex: this.params.rowIndex,
    };
    this.params.selectItemClick(rowData);
  }
}
